import { nanoid } from 'nanoid';
import { useState } from 'react';
import styled from 'styled-components';

const SwitchInput = styled(({ className, ...props }) => {
  const [id] = useState(() => `switch-${nanoid()}`);
  return (
    <div className={`custom-control custom-switch ${className}`}>
      <input
        id={id}
        type="checkbox"
        className="custom-control-input"
        {...props}
      />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="custom-control-label" htmlFor={id} />
    </div>
  );
})`
  margin: -2px -8px -2px 0;
  .custom-control-label::before,
  .custom-control-label::after {
    cursor: pointer;
  }
`;

export default SwitchInput;
